export const CORE_NODE_CLASS = "core-concept-node";

import { normalizeNodeImportance } from "./nodeContent.js";
import { hierarchyNodeMetrics, normalizeHierarchyEmphasis } from "./hierarchyEmphasis.js";
import { getMapTheme } from "./mapThemes.js";

export function getKnowledgeNodeStyle(importanceOrCore, hierarchyEmphasis = "balanced", themeId = "default") {
  const importance = normalizeNodeImportance(
    typeof importanceOrCore === "string" ? importanceOrCore : null,
    importanceOrCore === true
  );
  const isFocal = importance === "focal";
  const isCore = importance === "core";
  const isDetail = importance === "detail";
  const metrics = hierarchyNodeMetrics(importance, hierarchyEmphasis);
  const themeNodeStyle = getMapTheme(themeId).nodeStyle;
  const roleScale = isFocal ? themeNodeStyle.focalScale : isCore ? themeNodeStyle.coreScale : isDetail ? themeNodeStyle.detailScale : 1;
  const background = isFocal
    ? "var(--map-focal-node)"
    : isCore
      ? "var(--map-core-node)"
      : isDetail
        ? "var(--map-detail-node)"
        : "var(--map-node)";
  const borderColor = isFocal
    ? "var(--map-focal-border)"
    : isCore
      ? "var(--map-core-border)"
      : isDetail
        ? "var(--map-detail-border)"
        : "var(--map-node-border)";
  return {
    width: Math.round(metrics.width * themeNodeStyle.widthScale),
    minHeight: Math.round(metrics.minHeight * themeNodeStyle.heightScale * roleScale),
    padding: Math.max(4, Math.round(metrics.padding * themeNodeStyle.paddingScale * roleScale)),
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: isFocal
      ? "var(--map-node-radius-focal, 10px)"
      : isCore
        ? "var(--map-node-radius-core, 8px)"
        : isDetail
          ? "var(--map-node-radius-detail, 4px)"
          : "var(--map-node-radius-supporting, 6px)",
    background,
    border: `calc(${metrics.borderWidth}px * var(--map-node-border-scale, 1)) solid ${borderColor}`,
    color: "var(--map-text)",
    boxShadow: isFocal
      ? "var(--map-node-shadow-focal, 0 0 0 5px color-mix(in srgb, var(--map-focal-border) 20%, transparent), 0 12px 28px rgba(30,41,59,0.18))"
      : isCore
        ? "var(--map-node-shadow-core, 0 0 0 3px color-mix(in srgb, var(--map-core-border) 14%, transparent), 0 8px 18px rgba(30,41,59,0.14))"
        : isDetail
          ? "var(--map-node-shadow-detail, 1px 3px 4px rgba(15,23,42,0.08))"
          : "var(--map-node-shadow-supporting, 3px 6px 6px rgba(15,23,42,0.12))",
    fontSize: Math.max(9, Math.round(metrics.fontSize * themeNodeStyle.fontScale * roleScale * 10) / 10),
    fontWeight: isFocal
      ? "var(--map-node-weight-focal, 750)"
      : isCore
        ? "var(--map-node-weight-core, 650)"
        : isDetail
          ? "var(--map-node-weight-detail, 450)"
          : "var(--map-node-weight-supporting, 525)",
    lineHeight: isFocal ? 1.25 : 1.35,
    textAlign: "center",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  };
}

export function getEditorNodePresentation(importanceOrCore, hierarchyEmphasis = "balanced", themeId = "default") {
  const importance = normalizeNodeImportance(
    typeof importanceOrCore === "string" ? importanceOrCore : null,
    importanceOrCore === true
  );
  return {
    className: importance === "focal" || importance === "core" ? CORE_NODE_CLASS : "",
    style: getKnowledgeNodeStyle(importance, normalizeHierarchyEmphasis(hierarchyEmphasis), themeId),
  };
}
